<!-- eslint-disable vue/multi-word-component-names -->
<script>
import AppCard from '@/components/app/card.vue';
import StatusSwitcher from '@/components/BaseInformation/ChiefComplaint/StatusSwitcher.vue';
export default {
  components: {
    AppCard,
    StatusSwitcher,
  },
  props: {
    priority: {
      type: Number,
      default: 0,
      isRequired: true,
    },
    note: {
      type: String,
      default: '',
      isRequired: true,
    },
    status: {
      type: Boolean,
      default: false,
      isRequired: true,
    },
    accessDenyAddEditChief: {
      type: Boolean,
      default: false,
      isRequired: false,
    },
  },
};
</script>
<template>
  <app-card class="triageCard d-flex px-6 py-4 gap-4">
    <template v-slot:header>
      <div class="triageCard-header d-flex items-center pr-2">
        <div>
          {{ priority }}
        </div>
        <div class="triageCard-header-seperator"></div>
      </div>
    </template>
    <template v-slot:body>
      <section class="triageCard-body">
        <p>
          {{ note }}
        </p>
      </section>
    </template>
    <template v-slot:action>
      <!-- @click="$emit.enableAddEditFunction(2, item.id)" -->
      <section class="flex-gap-2 mr-auto">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div @click="accessDenyAddEditChief && $emit('click:changeStatus')" v-on="on" v-bind="attrs">
              <status-switcher :value="status" />
            </div>
          </template>
          <span>{{ status ? 'فعال' : 'غیرفعال' }}</span>
        </v-tooltip>
        <v-tooltip top v-if="accessDenyAddEditChief">
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="mt-1" color="iconColor" style="cursor: pointer" v-bind="attrs" v-on="on"
              @click="$emit('click:edit')">
              mdi-pencil
            </v-icon>
          </template>
          <span>ویرایش</span>
        </v-tooltip>
        <v-tooltip top v-if="accessDenyAddEditChief">
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="mt-1" color="iconColor" style="cursor: pointer" v-bind="attrs" v-on="on"
              @click="$emit('click:delete')">
              mdi-delete
            </v-icon>
          </template>
          <span>حذف</span>
        </v-tooltip>
      </section>
    </template>
  </app-card>
</template>
<style lang="scss">
.triageCard {
  border-right: 2px solid var(--v-darkColor-base);
  border-left: 2px solid var(--v-darkColor-base);
  border-top: 1.5px solid #eef6ff;
  border-bottom: 1.5px solid #eef6ff;
  border-radius: 12px;

  &-header {
    color: var(--v-darkColor-base);
    font-size: 22px;
    font-weight: 500;
    line-height: 34px;
    padding-right: 20px;

    &-seperator {
      margin-right: 8px;
      width: 2px;
      background-color: var(--v-darkColor-base);
      height: 50px;
    }
  }

  &-body {
    align-self: center;

    p {
      text-align: justify;
      font-size: 14px;
      line-clamp: 3;
      margin: 0 !important;
    }
  }
}
</style>
